import React from 'react'
import { Switch, Route } from 'react-router-dom'
// import RouteWithSubRoutes from 'components/common/RouteWithSubRoutes/RouteWithSubRoutes'
import ListRoute from './List'
import NotFoundRoute from "components/routes/NotFound";
import pathname from "./pathname";

const ContentComponent = () => (
  <Switch>
    <Route path={`${pathname}/:id?`} component={ListRoute} />

    <Route component={NotFoundRoute} /> {/* 404 */}
  </Switch>
)

export default ContentComponent

// export default () => (
//   <RouteWithSubRoutes
//     path="/visitors"
//     baseComponent={baseComponent}
//     subRoutes={[
//       /^\/visitors/,
//       // /^\/visitors\/([^\/])+$/,
//     ]}
//   />
// )
